'use client';

import { useParams } from 'next/navigation';
import { Error as ErrorComponent } from '../../components/error';

export function MappedError() {
  const params = useParams<{ code?: string }>();
  return <ErrorComponent code={params.code ?? 'Generic'} tryAgainButton />;
}
